/**
 * The site-wide bundle (app.js), loaded on every page. Keep it to what every page needs.
 * Page-specific code is its own Vite entry, pushed by the pages that use it (see vite.config.js):
 * echo.js (websockets), auto-revive-tracker.js, query-builder.js, planner.js, dashboard.js.
 */

/**
 * jQuery and Bootstrap. Bootstrap pulls in @popperjs/core for dropdowns and tooltips.
 */
import "./jquery-global";
import * as bootstrap from "bootstrap";
import axios from "axios";
import flatpickr from "flatpickr";
import * as Sentry from "@sentry/browser";

window.bootstrap = bootstrap;

/**
 * axios sends the CSRF token from the XSRF-TOKEN cookie automatically.
 */
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * flatpickr, for the shared TCT date/time picker (resources/js/tct-picker.js) used across many forms.
 */
window.flatpickr = flatpickr;

/**
 * window.siteConfig comes from partials/_site-config, rendered by the server, so one build works for
 * every environment.
 */
Sentry.init({
    dsn: window.siteConfig?.sentryDsn || undefined,
});
